import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: window.ossoConfig?.appInsightsKey,
    // dont track LogRocket requests
    excludeRequestFromAutoTrackingPatterns: [/^https:\/\/r\.lgrckt-in\.com/]
  }
})

if (!navigator.webdriver && window.ossoConfig?.appInsightsKey) {
  appInsights.loadAppInsights()
}
